<div class="flex flex-wrap items-center gap-1">
  @if (appliedFilters) {
    @if (filter.name && appliedFilters[filter.name]) {
      <span class="capitalize tracking-wider"
        >{{ filter.name | humanize }}:&nbsp;</span
      >
    }
    @switch (filter.type) {
      @case ("dropdown") {
        <!-- NOTE: changes here should likely be made to the below 'dropdown-single' case too -->
        @for (
          appliedFilter of appliedFilters[filter.name];
          track appliedFilterTrackBy(index, appliedFilter)
        ) {
          <div
            class="flex select-none items-center gap-2 rounded-full bg-slate-200 px-2 text-slate-800"
          >
            <span
              class="max-w-[30ch] overflow-x-hidden text-ellipsis whitespace-nowrap capitalize"
            >
              {{ appliedFilter?.label }}
            </span>
          </div>
        }
      }
      @case ("dropdown-single") {
        <!-- NOTE: changes here should likely be made to the above 'dropdown' case too -->
        @for (
          appliedFilter of appliedFilters[filter.name];
          track appliedFilterTrackBy(index, appliedFilter)
        ) {
          <div
            class="flex select-none items-center gap-2 rounded-full bg-slate-200 px-2 text-slate-800"
          >
            <span
              class="max-w-[30ch] overflow-x-hidden text-ellipsis whitespace-nowrap capitalize"
            >
              {{ appliedFilter?.label }}
            </span>
          </div>
        }
      }
      @case ("dateRange") {
        @if (startDateRange) {
          <div
            class="flex select-none items-center gap-2 rounded-full bg-slate-200 px-2 text-slate-800"
          >
            <span class="max-w-[30ch] overflow-x-hidden text-ellipsis">
              Start: {{ startDateRange | date: "d MMM y" }}
            </span>
          </div>
        }
        @if (endDateRange) {
          <div
            class="flex select-none items-center gap-2 rounded-full bg-slate-200 px-2 text-slate-800"
          >
            <span class="max-w-[30ch] overflow-x-hidden text-ellipsis">
              End: {{ endDateRange | date: "d MMM y" }}
            </span>
          </div>
        }
        @if (dateRangePresetOption) {
          <div
            class="flex select-none items-center gap-2 rounded-full bg-slate-200 px-2 text-slate-800"
          >
            <span class="max-w-[30ch] overflow-x-hidden text-ellipsis">
              {{ dateRangePresetOption }}
            </span>
          </div>
        }
      }
      @case ("week") {
        @if (startWeek) {
          <div
            class="flex select-none items-center gap-2 rounded-full bg-slate-200 px-2 text-slate-800"
          >
            <span class="max-w-[30ch] overflow-x-hidden text-ellipsis">
              Start: {{ startWeek }}
            </span>
          </div>
        }
        @if (endWeek) {
          <div
            class="flex select-none items-center gap-2 rounded-full bg-slate-200 px-2 text-slate-800"
          >
            <span class="max-w-[30ch] overflow-x-hidden text-ellipsis">
              End: {{ endWeek }}
            </span>
          </div>
        }
      }
      @case ("text") {
        @if (text) {
          <div
            class="flex select-none items-center gap-2 rounded-full bg-slate-200 px-2 text-slate-800"
          >
            <span class="max-w-[30ch] overflow-x-hidden text-ellipsis">
              {{ text }}
            </span>
          </div>
        }
      }
      @case ("number") {
        @if (number) {
          <div
            class="flex select-none items-center gap-2 rounded-full bg-slate-200 px-2 text-slate-800"
          >
            <span class="max-w-[30ch] overflow-x-hidden text-ellipsis">
              {{ number }}
            </span>
          </div>
        }
      }
    }
  }
</div>
